import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=d1a8da48&scoped=true"
import script from "./GroupTable.vue?vue&type=script&lang=js"
export * from "./GroupTable.vue?vue&type=script&lang=js"
import style0 from "./GroupTable.vue?vue&type=style&index=0&id=d1a8da48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a8da48",
  null
  
)

export default component.exports